export const getDiscountValue = (price, discount) => {
  return Math.round(price * (discount / 100)).toString();
};
